import React from 'react'
import { ModalOrderColumn } from '../smart_bps/bps/components/modal_order_column'

export class SigurModalOrderColumn extends ModalOrderColumn {

  constructor(props) {
    super(props)
    this.normalizeColumns = this.normalizeColumns.bind(this)
  }

  /** Первая колонка в реестре — фиксированная (всегда первая, без удаления). */

  getFixedHeader() {
    return this.props.table_headers?.[0]
  }

  normalizeColumns(headers) {
    const fixed = this.getFixedHeader()
    const base = headers?.length ? [...headers] : [...this.props.table_headers]
    if (!fixed) {
      return base
    }
    const rest = base.filter((col) => col !== fixed)
    return [fixed, ...rest]
  }

  componentDidMount() {
    this.setState({
      user_table_headers: this.normalizeColumns(this.props.user_table_headers),
    })
  }

  getColumns() {
    return this.normalizeColumns(this.state.user_table_headers)
  }

  changeFields(idx, action) {
    let columns = [...this.getColumns()]
    const fixed = this.getFixedHeader()
    const elem = columns[idx]

    if (fixed && elem === fixed) {
      return
    }

    if (action === "trash") {
      columns.splice(idx, 1)
    } else if (action === "down" && idx + 1 < columns.length) {
      columns.splice(idx, 1)
      columns.splice(idx + 1, 0, elem)
    } else if (action === "up" && idx > 1) {
      columns.splice(idx, 1)
      columns.splice(idx - 1, 0, elem)
    }

    this.setState({ user_table_headers: this.normalizeColumns(columns) })
  }

  applyChange(action) {
    if (action !== "reset") {
      this.setState(
        (prev) => ({
          user_table_headers: this.normalizeColumns(prev.user_table_headers),
        }),
        () => super.applyChange(action),
      )
      return
    }
    super.applyChange(action)
  }

  render() {
    const attrs = this.props.attrs
    const current_columns = this.getColumns()
    const td_icon_style = { width: "50px" }
    const fixedTableHeader = this.getFixedHeader()
    const fixedAttr = fixedTableHeader ? attrs[fixedTableHeader] : null
    const editable_columns = fixedTableHeader
      ? current_columns.filter((col) => col !== fixedTableHeader)
      : current_columns

    const disabled_cols = this.props.table_headers.map(attr_name => {
    if (!current_columns.includes(attr_name)) {
      const attr = attrs[attr_name]

      const restoreField = () => {
        const cols = this.normalizeColumns(this.getColumns())
        if (!cols.includes(attr_name)) {
          cols.push(attr_name)
        }
        this.setState({ user_table_headers: cols })
      }

      if (fixedTableHeader !== attr_name) {
        return (
          <span
            className="badge text-bg-secondary me-1 mb-1 pointer"
            onClick={restoreField}
            key={attr_name}
          >
            {attr.title}
          </span>
        )
      }
    }

    return null
  })

    return (
      <div className="modal fade" id="modal_order_column" tabIndex="-1" aria-hidden="true" key="modal_order_column">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel1">Настройка колонок</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <table className="table table-hover mb-3">
                <tbody>
                  {fixedTableHeader && fixedAttr && (
                    <tr key={fixedTableHeader} className="text-muted">
                      <td>{fixedAttr.title}</td>
                      <td colSpan={3} className="small">Всегда в реестре</td>
                    </tr>
                  )}
                  {editable_columns.map((attr_name) => {
                    const idx = current_columns.indexOf(attr_name)
                    const attr = attrs[attr_name]

                    return (
                      <tr key={attr_name}>
                        <td>
                          {attr.title}
                        </td>
                        {idx > 1 && (<td style={td_icon_style}>
                          <span className="ti ti-circle-arrow-up pointer" onClick={() => {
                            this.changeFields(idx, "up")
                          }}></span>
                        </td>
                        )}
                        {idx <= 1 && (<td></td>)}
                        {(idx + 1) < current_columns.length && (<td style={td_icon_style}>
                          <span className="ti ti-circle-arrow-down pointer" onClick={() => {
                            this.changeFields(idx, "down")
                          }}></span>
                        </td>
                        )}
                        {idx + 1 >= current_columns.length && (<td></td>)}
                        <td style={td_icon_style}>
                          <span className="ti ti-trash text-danger pointer" onClick={() => {
                            this.changeFields(idx, "trash")
                          }}></span>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>

              {disabled_cols && <div>
                <h5>Отключенные параметры</h5>
                {disabled_cols}
              </div>}

            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary p-2 me-1" onClick={this.applyChange} data-bs-dismiss="modal">
                <span className="ti ti-check me-1"></span>
                Применить
              </button>
              <button type="button" className="btn btn-danger p-2 me-1" onClick={() => { this.applyChange("reset") }} data-bs-dismiss="modal">
                <span className="ti ti-trash me-1"></span>
                Сброс
              </button>
              <button type="button" className="btn btn-secondary p-2 me-1" data-bs-dismiss="modal">
                Закрыть
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

